'use strict';

const { h } = require('phy');

const alphaList = require('../../support/alpha-numeric')();

function BrowseByLetter({ merchants }) {
  const letterList = alphaList.map((value, index) =>
    h(
      'li.browse-letter-item',
      h(
        `a.browse-letter-link${!merchants[index].length ? '.disable' : ''}`,
        {
          href: merchants[index].length ? `#${value}` : null,
          'data-bhc': `letter:${value}`,
        },
        value
      )
    )
  );

  return h(
    '.browse-letter',
    h(
      'ul.browse-letter-list',
      {
        'data-bhw': 'BrowseLetter',
      },
      letterList
    )
  );
}

module.exports = BrowseByLetter;
